module.exports = __webpack_public_path__ + "media/img/trainee-program/card_career-6a3a2ae3b983b14ec823fc4b232860d5.jpg";